var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.642,
    height: 44.239,
    viewBox: "0 0 47.642 44.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.174,
    y1: -146.919,
    x2: 0.826,
    y2: -145.787,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel-svgrepo-com",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105898",
    "data-name": "Path 105898",
    d: "M27.346,16.718,8.512,13.4V37.917a2.028,2.028,0,0,0,2.03,2.026h32.5a2.028,2.028,0,0,0,2.033-2.026h0V28.884Z",
    transform: "translate(4.568 7.295)",
    fill: "#185c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105899",
    "data-name": "Path 105899",
    d: "M27.346,3h-16.8a2.028,2.028,0,0,0-2.03,2.026h0V14.06l18.834,11.06,9.972,3.318,7.755-3.318V14.06Z",
    transform: "translate(4.568 0)",
    fill: "#21a366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105900",
    "data-name": "Path 105900",
    d: "M8.512,9.5H27.346V20.56H8.512Z",
    transform: "translate(4.568 4.56)",
    fill: "#107c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105901",
    "data-name": "Path 105901",
    d: "M21.991,8.2H8.512V35.849H21.991a2.042,2.042,0,0,0,2.032-2.026v-23.6A2.042,2.042,0,0,0,21.991,8.2Z",
    transform: "translate(4.568 3.648)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105902",
    "data-name": "Path 105902",
    d: "M20.884,8.85H8.512V36.5H20.884a2.042,2.042,0,0,0,2.032-2.026v-23.6A2.042,2.042,0,0,0,20.884,8.85Z",
    transform: "translate(4.568 4.104)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105903",
    "data-name": "Path 105903",
    d: "M20.884,8.85H8.512V34.287H20.884a2.042,2.042,0,0,0,2.032-2.026V10.876A2.042,2.042,0,0,0,20.884,8.85Z",
    transform: "translate(4.568 4.104)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105904",
    "data-name": "Path 105904",
    d: "M19.776,8.85H8.512V34.287H19.776a2.042,2.042,0,0,0,2.032-2.026V10.876A2.042,2.042,0,0,0,19.776,8.85Z",
    transform: "translate(4.568 4.104)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105905",
    "data-name": "Path 105905",
    d: "M4.032,8.85H24.344a2.03,2.03,0,0,1,2.032,2.026V31.155a2.03,2.03,0,0,1-2.032,2.026H4.032A2.028,2.028,0,0,1,2,31.155V10.876A2.028,2.028,0,0,1,4.032,8.85Z",
    transform: "translate(0 4.104)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105906",
    "data-name": "Path 105906",
    d: "M5.7,25.307,9.972,18.7,6.059,12.127H9.2l2.135,4.208a8.182,8.182,0,0,1,.4.892h.029c.14-.32.288-.628.442-.929L14.5,12.134h2.893l-4.014,6.534,4.116,6.644H14.413L11.946,20.7a4.007,4.007,0,0,1-.291-.621h-.041a2.872,2.872,0,0,1-.286.6l-2.54,4.631Z",
    transform: "translate(2.596 6.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105907",
    "data-name": "Path 105907",
    d: "M35.277,3h-15.7V14.06H37.309V5.026A2.028,2.028,0,0,0,35.277,3Z",
    transform: "translate(12.333 0)",
    fill: "#33c481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105908",
    "data-name": "Path 105908",
    d: "M19.581,16H37.309V27.06H19.581Z",
    transform: "translate(12.333 9.119)",
    fill: "#107c41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.e5c980285dcd12a33f192b88ecc6fec4.svg";
export { ForwardRef as ReactComponent };